var LocalStorageService = (function () {
    function LocalStorageService() {
    }
    LocalStorageService.prototype.getItem = function (item) {
        try {
            return window.localStorage.getItem(item);
        }
        catch (exception) {
            return null;
        }
    };
    LocalStorageService.prototype.setItem = function (key, value) {
        try {
            return window.localStorage.setItem(key, value);
        }
        catch (exception) {
            return null;
        }
    };
    LocalStorageService.prototype.removeItem = function (item) {
        try {
            return window.localStorage.removeItem(item);
        }
        catch (exception) {
            return null;
        }
    };
    return LocalStorageService;
}());
export { LocalStorageService };
//# sourceMappingURL=localstorage.service.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/localstorage.service.js
// module id = 60
// module chunks = 0